/**
 * Alert component - Reusable alert/notification
 */
import React from 'react';

const Alert = ({
  children,
  variant = 'info',
  className = '',
  dismissible = false,
  onClose,
  icon
}) => {
  const iconMap = {
    success: 'bi-check-circle',
    danger: 'bi-exclamation-circle',
    warning: 'bi-exclamation-triangle',
    info: 'bi-info-circle'
  };

  const defaultIcon = iconMap[variant] || 'bi-info-circle';

  return (
    <div className={`alert alert-${variant} ${dismissible ? 'alert-dismissible fade show' : ''} ${className}`} role="alert">
      {icon !== false && (
        <i className={`bi ${icon || defaultIcon} me-2`}></i>
      )}
      {children}
      {dismissible && (
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
        ></button>
      )}
    </div>
  );
};

export default Alert;
